import React from 'react';

import Campaign from '~/containers/Outside/Campaign';

export default function CampaignAnswer() {
  return (
    <Campaign />
  );
}
